import React from 'react';

import Hero from '../components/our-team/Hero'
import MeetFMS from '../UI/MeetFms'
import Team from '../components/our-team/team'

const OurTeam = () => {
  return (
    <div className="w-full">
      <Hero/>
      <MeetFMS/> 
      <Team/>
    </div>
  );
};

export default OurTeam;
